export default class FreelancerUserManagerEditItem {
  constructor(item) {
    if (item) {
      this.FreelancerUserId = item.FreelancerUserId;
      this.FreelancerRoleIds = item.FreelancerRoleIds ? item.FreelancerRoleIds : [];
      this.RmFreelancerUserManagers = item.RmFreelancerUserManagers ? item.RmFreelancerUserManagers : [];
      this.DqFreelancerUserManagers = item.DqFreelancerUserManagers ? item.DqFreelancerUserManagers : [];
      this.UserType = item.UserType;
    }

    this.ManagerId = null;
    this.DepartmentLookupItemValue = null;
    this.ThirdPartySource = null;
  }
}
